import type { Dispatch } from 'redux';

let dispatchRef: Dispatch | null = null;

export const bindDispatch = (dispatch: Dispatch) => {
  dispatchRef = dispatch;
};

export const getDispatch = (): Dispatch | null => dispatchRef;
